import React, { useEffect } from 'react';
import { Col, Container, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import PageTitle from 'components/titles/PageTitle';
import Reports from 'components/Reports/index';
import { injectSatismeter } from '../../utils/satismeter';


const ReportPage = (props) => {
  useEffect(() => {
    injectSatismeter();
  }, []);

  return (
    <Container>
      <PageTitle>Analytics</PageTitle>
      <Row>
        <Col className="reports mb-5">
          <Reports location={props.location} match={props.match} />
        </Col>
      </Row>
    </Container>
  );
};


ReportPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    path: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default ReportPage;
